export enum StatusEnum {
    init = "Init",
    readyForReview = "ReadyForReview",
    readyForPublish = "ReadyForPublish",
    published = "Published",
}